/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "Akayupawa Budasuera",
          "chinese": "Akayupawa Xinawara",
          "coptic": "Akayupawa Kupitiku",
          "dangi": "Akayupawa Dãgi",
          "ethiopic": "Akayupawa Etíupi",
          "ethiopic-amete-alem": "Akayupawa Amete Alem Etiupiwara",
          "gregorian": "Akayupawa Greguriuwara",
          "hebrew": "Akayupawa Yudeu",
          "indian": "Akayupawa Tetãmapawa Ĩdiawara",
          "islamic": "Akayupawa Islãsuera",
          "islamic-civil": "Akayupawa Siwiu Islãsuera",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "Akayupawa Islãsuera (Umm al-Qura)",
          "iso8601": "Akayupawa ISSO-8601",
          "japanese": "Akayupawa Nipõwara",
          "persian": "Akayupawa Persiyawara",
          "roc": "Akayupawa Xina Repúbirikawara"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "Peseta Ãdurawara",
          "AED": "Dirhã Emiradu-ita Árabe Yepewasú",
          "AFA": "Afegani (1927–2002)",
          "AFN": "Afegani afegawara",
          "ALK": "Reki Aubaniawara (1946–1965)",
          "ALL": "Reki aubanei",
          "AMD": "Darã arimeniawara",
          "ANG": "Fulurĩ Ãtíria Hurãdawara",
          "AOA": "Kuãsa ãgulawara",
          "AOK": "Kuãsa ãgulawara (1977–1990)",
          "AON": "Kuãsa ãgulawara pisasuwa (1990–2000)",
          "AOR": "Kuãsa ãgulawara yumũñãwa yuiri (1995–1999)",
          "ARA": "Austarau Argẽtinawara",
          "ARL": "Pusewa tekú Argẽtinawara (1970–1983)",
          "ARM": "Pusewa argẽtinu (1981–1970)",
          "ARP": "Pusewa argẽtinu (1983–1985)",
          "ARS": "Pusewa argẽtinu",
          "ATS": "Xirĩ ausitíriaku",
          "AUD": "Dóra Ausitaraliwara",
          "AWG": "Fulurĩ Arubawara",
          "AZM": "Manati Aseriretãmawara (1993–2006)",
          "AZN": "Manati aseri",
          "BAD": "Dinari Businiya-Eseguwinawara (1992–1994)",
          "BAM": "Marku yumuyerewa Businiya-Eseguwinawara",
          "BAN": "Dinari Pisasuwa Businiya-Eseguwinawara (1994–1997)",
          "BBD": "Dóra barbaduwara",
          "BDT": "Taka Bẽgariwara",
          "BEC": "Farãku Beujikawara (yumuyereuwa)",
          "BEF": "Farãku Beujikawara",
          "BEL": "Farãku Beujikawara (finãseru)",
          "BGL": "Revi Kirĩbawa Bugariyawara",
          "BGM": "Revi Susiaritawa Bugariyawara",
          "BGN": "Revi Bugariyawara",
          "BGO": "Revi Bugariyawara (1879–1952)",
          "BHD": "Dinari Barẽiwara",
          "BIF": "Farãku Burũdiwara",
          "BMD": "Dóra Bemudawara",
          "BND": "Dóra Buruneiwara",
          "BOB": "Buriwiyanu Buríwia suí",
          "BOL": "Buriwiyanu (1863–1963)",
          "BOP": "Pusewa buriwiyanu",
          "BOV": "Mvdol buriwiyanu",
          "BRB": "Kuruseru Pisasuwa Brasiuwara (1967–1986)",
          "BRC": "Kurusadu Brasiuwara (1986–1989)",
          "BRE": "Kuruseru Brasiuwara (1990–1993)",
          "BRL": "Reau Brasiuwara",
          "BRN": "Kurusadu Pisasuwa Brasiuwara (1989–1990)",
          "BRR": "Kuruseiru Brasiuwara (1993–1994)",
          "BRZ": "Kuruseiru Brasiuwara (1942–1967)",
          "BSD": "Dóra Bayamawara",
          "BTN": "Ĩguturũ Butãwara",
          "BUK": "Kiati Bimãniyawara",
          "BWP": "Pura Butisuwanawara",
          "BYB": "Ruburu Pisasuwa Bieru-rusiyawara (1994–1999)",
          "BYN": "Ruburu bieruruso",
          "BYR": "Ruburu bieruruso (2000–2016)",
          "BZD": "Dóra Belisiwara",
          "CAD": "Dóra Kanadáwara",
          "CDF": "Farãku Kũguwara",
          "CHE": "Euru WIR",
          "CHF": "Farãku Suwisawara",
          "CHW": "Farãku WIR",
          "CLE": "Warakapá Xiriwara",
          "CLF": "Yepesawa-ita Muapiresawa Xiriwara",
          "CLP": "Pusewa Xiriwara",
          "CNH": "Yuwã Xinawara (offshore)",
          "CNX": "Dóra Bãku Pupulari Xinawara suí",
          "CNY": "Yuwã Xinawara",
          "COP": "Peso Kurũbiyawara",
          "COU": "Yepesawa Sepisawa Reau suiwara",
          "CRC": "Kurũ Kupe-Rikawara",
          "CSD": "Dinari Sewiyawara (2002–2006)",
          "CSK": "Kuruwa Kirĩbawa Xekusirowaka",
          "CUC": "Pusewa Kubawara Yumuyerewa",
          "CUP": "Pusewa Kubawara",
          "CVE": "Warakapá Kabu-Suikiriwara",
          "CYP": "Ribara Xipiriwara",
          "CZK": "Kuruwa Xekawara",
          "DDM": "Ostmark Aremãya Uriẽtawara",
          "DEM": "Marku Aremãyawara",
          "DJF": "Farãku Digibutiwara",
          "DKK": "Kuruwa Dinamakawara",
          "DOP": "Pusewa Dominikawara",
          "DZD": "Dinari Argeriyawra",
          "ECS": "Sukiri Ekuaduwara",
          "ECV": "Yepesawa Sepisawa Piá-sãtá (UVS) Ekuaduwara",
          "EEK": "Kuruwa Isituniyawara",
          "EGP": "Ribara Egituwara",
          "ERN": "Nakiwa Eritireyawara",
          "ESA": "Peseta Isipãyawara (kãta A)",
          "ESB": "Peseta Isipãyawara (kãta yumuyerewa)",
          "ESP": "Peseta Isipãyawara",
          "ETB": "Biri Etiupiyawara",
          "EUR": "Euru",
          "FIM": "Marka Firãdiyawara",
          "FJD": "Dóra Fiyiwara",
          "FKP": "Ribara Mawinawara",
          "FRF": "Farãku Frãsawara",
          "GBP": "Ribara esiterina",
          "GEK": "Kupũ Rari Geugiyawara",
          "GEL": "Rari geugiyanu",
          "GHC": "Sedi Ganawara (1979–2007)",
          "GHS": "Sedi ganei",
          "GIP": "Ribara Gibarautáwara",
          "GMD": "Darasi Gãbiyawara",
          "GNF": "Farãku Ginewara",
          "GNS": "Siri Ginewara",
          "GQE": "Ekiwere Giné Ekuatoriyawara",
          "GRD": "Darakima Geresiyawara",
          "GTQ": "Ketisau Guatemawara",
          "GWE": "Warakapá Giné Purutugesawara",
          "GWP": "Pusewa Giné-Bisawara",
          "GYD": "Dóra Gianawara",
          "HKD": "Dóra Hũgi-Kũgiwara",
          "HNL": "Ribara Ũdurawara",
          "HRD": "Dinari Kuruwasiyawara",
          "HRK": "Kuna Kuruata",
          "HTG": "Gourde Aitiwara",
          "HUF": "Fulurĩ Ũgiriyawara",
          "IDR": "Rupiya Ĩdunesiyawara",
          "IEP": "Ribara Irãdawara",
          "ILP": "Ribara Isirayewara",
          "ILR": "Xekeu Kuxiímawara Isirayerita",
          "ILS": "Pisusawa Xekeu Isiraelẽsi",
          "INR": "Rupiya Ĩdiawara",
          "IQD": "Dinari Irakiwara",
          "IRR": "Riau Irãwara",
          "ISJ": "Kuruwa Kuxiímawara Isirãdiawara",
          "ISK": "Kuruwa Isirãdiawara",
          "ITL": "Rira Itariyawara",
          "JMD": "Dóra Yamaikawara",
          "JOD": "Dinari Yudâniyawara",
          "JPY": "Iyene Nipõwara",
          "KES": "Xirĩ Kẽniyawara",
          "KGS": "Sumu Kirigiretãmawara",
          "KHR": "Rieu Kãbuyawara",
          "KMF": "Farãku Kumurewara",
          "KPW": "Wõ nuti-kureyanu",
          "KRH": "Huwã Kureya-Suwara",
          "KRO": "Wõ Kureya-Suwara (1945–1953)",
          "KRW": "Wõ su-kureyanu",
          "KWD": "Dinari Kuwaitiwara",
          "KYD": "Dóra Kaimãwara",
          "KZT": "Tẽge Kasakiwara",
          "LAK": "Kipi Rawosiwara",
          "LBP": "Ribara Ribanuwara",
          "LKR": "Rupiya Sirirãkawara",
          "LRD": "Dóra Riberiyawara",
          "LSL": "Ruti Resutuwara",
          "LTL": "Rita Rituwãniwara",
          "LTT": "Taruna rituwãnu",
          "LUC": "Farãku yumuyerewa Ruxẽbuguwara",
          "LUF": "Farãku Ruxẽbuguwara",
          "LUL": "Farãku finãseru Ruxẽbuguwara",
          "LVL": "Rati Retuniyawara",
          "LVR": "Ruburu Retuniyawara",
          "LYD": "Dinari Ribiyawara",
          "MAD": "Dirhã Marukuwara",
          "MAF": "Farãku Marukuwara",
          "MCF": "Farãku Mũnakuwara",
          "MDC": "Kupũ Mũduwara",
          "MDL": "Leyu mudawiu",
          "MGA": "Ariyari maugaxi",
          "MGF": "Farãku Madagasikawara",
          "MKD": "Dinari Maseduniyawara",
          "MKN": "Dinari Maseduniyawara (1992–1993)",
          "MLF": "Farãku Mariwara",
          "MMK": "Kiyati Miayamawara",
          "MNT": "Tugiriki Mũguriyawara",
          "MOP": "Pataka Makauwara",
          "MRO": "Wogiya Makauwara (1973–2017)",
          "MRU": "Wogiya Mauritaniwara",
          "MTL": "Rira Mautawara",
          "MTP": "Ribara mautesa",
          "MUR": "Rupiya Maurisiwara",
          "MVP": "MVP",
          "MVR": "Rupiya Maudiwawara",
          "MWK": "Kuaxa Marawiwara",
          "MXN": "Pusewa Mexikuwara",
          "MXP": "Pusewa Parata suiwara mexikanu (1861–1992)",
          "MXV": "Yepesawa Mexikuwara Ĩwetiriarama (UDI)",
          "MYR": "Rĩgiti malayu",
          "MZE": "Warakapá Musãbikiwara",
          "MZM": "Metikau Musãbikiwara (1980–2006)",
          "MZN": "Metikau Musãbikiwara",
          "NAD": "Dóra Namibiyawara",
          "NGN": "Naira Nigeriyawara",
          "NIC": "Koduba Nikaraguwara (1988–1991)",
          "NIO": "Koduba Nikaraguwara",
          "NLG": "Fulurĩ Hurãdawara",
          "NOK": "Kuruwa Nuruwegawara",
          "NPR": "Rupiya Nepauwara",
          "NZD": "Dóra neuserãdewa",
          "OMR": "Riyau Umãwara",
          "PAB": "Baubowa Panamawara",
          "PEI": "Ĩti Peruwara",
          "PEN": "Pisasuwa Kurasí Peruwara",
          "PES": "Kurasí Peruwara (1863–1965)",
          "PGK": "Kina Papuwara",
          "PHP": "Pusewa Firipinawara",
          "PKR": "Rupiya Pakiretãwara",
          "PLN": "Ziroti Puruniyawara",
          "PLZ": "Ziroti Puruniyawara (1950–1995)",
          "PTE": "Warakapá Purutugawara",
          "PYG": "Guwarani Paraguwaiwara",
          "QAR": "Riyau Katawara",
          "RHD": "Dóra Rudesiyawara",
          "ROL": "Leu Rumeniyawara (1952–2006)",
          "RON": "Leu Rumeniyawara",
          "RSD": "Dinari Sewiyawara",
          "RUB": "Ruburu Rusiyawara",
          "RUR": "Ruburu Rusiyawara (1991–1998)",
          "RWF": "Farãku Ruãdawara",
          "SAR": "Riyau Sauditawara",
          "SBD": "Dóra Kapuãma-ita Sarumũ yara",
          "SCR": "Rupiya Seixeriwara",
          "SDD": "Dinari Sudawara (1992–2007)",
          "SDG": "Ribara Sudawara",
          "SDP": "Ribara Sudawara (1957–1998)",
          "SEK": "Kuruwa Suwésiyawara",
          "SGD": "Dóra Sĩgapurawara",
          "SHP": "Ribara Sãta Herena yara",
          "SIT": "Tora Katuwa Esiruweniyawara",
          "SKK": "Kuruwa Esirowaka",
          "SLL": "Rioni Iwitera Reuwa yara",
          "SOS": "Xerĩ Sumariyawara",
          "SRD": "Dóra Surinãmiyawara",
          "SRG": "Fulurĩ Surinami yara",
          "SSP": "Ribara Su-Sudãniyawara",
          "STD": "Dobara Sãtu Tumé asuí Pirĩsipi yara (1977–2017)",
          "STN": "Dobara Sãtu Tumé asuí Pirĩsipi yara",
          "SUR": "Ruburu Suwiyetikawara",
          "SVC": "Kurũ Sauwadú yara",
          "SYP": "Ribara Síriya",
          "SZL": "Rirãgeni Suwasiretãmawara",
          "THB": "Baht Tairetãmawara",
          "TJR": "Ruburu Tayikiretãmawara",
          "TJS": "Sumuni tayiki",
          "TMM": "Manati Turkuranaretãma yara (1993–2009)",
          "TMT": "Manati turkumenu",
          "TND": "Dinari Tunisiyawara",
          "TOP": "Pawãga Tũgawara",
          "TPE": "Warakapá Timuwara",
          "TRL": "Rira turka (1922–2005)",
          "TRY": "Rira turka",
          "TTD": "Dóra Tirinidadi asuí Tobagu yara",
          "TWD": "Pisasuwa Dóra Taiwãwara",
          "TZS": "Xerĩ Tãsaniyawara",
          "UAH": "Hiryuwiniya Ukaraniyãwara",
          "UAK": "Kabuwaneti Ukaraniyãwara",
          "UGS": "Xerĩ Ugãdawara (1966–1987)",
          "UGX": "Xerĩ Ugãdawara",
          "USD": "Dóra Mexikuwara",
          "USN": "Dóra nuti-amerikawa (amũ ára)",
          "USS": "Dóra nuti-amerikawa (aramẽ wára)",
          "UYI": "Pusewa Uruguwaiwara yepesawa ĩdekisada-ita upé",
          "UYP": "Pusewa Uruguwaiwara (1975–1993)",
          "UYU": "Pusewa Uruguwaiwara",
          "UYW": "UYW",
          "UZS": "Sumu Yũbuesara-retãmawara",
          "VEB": "Buriwari Wenesuerawara (1871–2008)",
          "VEF": "Buriwari Wenesuerawara (2008–2018)",
          "VES": "Buriwari Wenesuerawara",
          "VND": "Dong wietinamita",
          "VNN": "Dong wietinamita (1978–1985)",
          "VUV": "Watu Wanuatu yara",
          "WST": "Tara Samuwara",
          "XAF": "Farãku CFC BEAC yara",
          "XAG": "Parata",
          "XAU": "Ouru",
          "XBA": "Yepesawa siiyawita Eurupawara",
          "XBB": "Yepesawa munetariya Eurupawara",
          "XBC": "Yepesawa kũta Eurupawara (XBC)",
          "XBD": "Yepesawa kũta Eurupawara (XBD)",
          "XCD": "Dóra Karibi Uriẽtawara yara",
          "XDR": "Yupitasukasa Yãkatuwa Musakasawa",
          "XEU": "Yepesawa Muweda Eurupawara",
          "XFO": "Farãku-ouru Farãsawara",
          "XFU": "Farãku UIC Farãsawara",
          "XOF": "Farãku CFA BCEAO yara",
          "XPD": "Parádiyu",
          "XPF": "Farãku CFP",
          "XPT": "Paratina",
          "XRE": "Fũdu RINET",
          "XSU": "XSU",
          "XTS": "Kudigu Muweda Yusã yara",
          "XUA": "XUA",
          "XXX": "Moweda ũbawaukua awa",
          "YDD": "Dinari Yemẽwara",
          "YER": "Riyau yeminita",
          "YUD": "Dinari kirĩbawa Yugusirawiawara (1966–1990)",
          "YUM": "Dinari pisasuwa yugusirawia (1994–2002)",
          "YUN": "Dinari yumuyerewa Yugusirawiawara (1990–1992)",
          "YUR": "Dinari yũpisasuwa Yugusirawiawara (1992–1993)",
          "ZAL": "Rãdi su-afirikanu (finãseru)",
          "ZAR": "Rãdi-ita Afirika Su kitiwara",
          "ZMK": "Kuwaxa sãbianu (1968–2012)",
          "ZMW": "Kuwaxa sãbianu",
          "ZRN": "Saire Pisasuwa Sairewara (1993–1998)",
          "ZRZ": "Saire Sairewara (1971–1993)",
          "ZWD": "Dóra Sĩbabuwewara (1980–2008)",
          "ZWL": "Dóra Sĩbabuwewara (2009)",
          "ZWR": "Dóra Sĩbabuwewara (2008)"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "ara",
          "dayOfYear": "ara akayú suí",
          "dayperiod": "a. m./p. m.",
          "era": "era",
          "hour": "hura",
          "minute": "minutu",
          "month": "yasí",
          "quarter": "musapíri-yasí",
          "second": "segũdu",
          "timeZoneName": "eimã hura suí",
          "weekOfMonth": "sẽmãna suí yasí suí",
          "weekOfYear": "sẽmãna",
          "weekday": "ara sẽmãna suí",
          "weekdayOfMonth": "ara sẽmãna suí yasí suí",
          "year": "akayú"
        },
        "narrow": {
          "day": "ara",
          "dayOfYear": "ara a.s.",
          "dayperiod": "a. m./p. m.",
          "era": "era",
          "hour": "h",
          "minute": "min.",
          "month": "yasí",
          "quarter": "mu-y.",
          "second": "seg.",
          "timeZoneName": "eimã",
          "weekOfMonth": "s.s. y.s.",
          "weekOfYear": "sẽm.",
          "weekday": "ara s.s.",
          "weekdayOfMonth": "ara s.s. y.s.",
          "year": "akayú"
        },
        "short": {
          "day": "ara",
          "dayOfYear": "ara a. suí",
          "dayperiod": "a. m./p. m.",
          "era": "era",
          "hour": "h",
          "minute": "min.",
          "month": "yasí",
          "quarter": "mu-y.",
          "second": "seg.",
          "timeZoneName": "eimã",
          "weekOfMonth": "s. suí y. suí",
          "weekOfYear": "sẽm.",
          "weekday": "ara s. suí",
          "weekdayOfMonth": "ara s. suí y. suí",
          "year": "akayú"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "afari",
            "ab": "abikasiyu",
            "ace": "axemi",
            "ach": "akuri",
            "ada": "adãgime",
            "ady": "adige",
            "ae": "awesitiku",
            "af": "afiriķãner",
            "afh": "afirihiri",
            "agq": "agẽ",
            "ain": "ainú",
            "ak": "akã",
            "akk": "akadiãnu",
            "ale": "areúti",
            "alt": "autai meridiunau",
            "am": "amáriku",
            "an": "aragunẽi",
            "ang": "ẽgirixi arkaiku",
            "anp": "ãyika",
            "ar": "arabi",
            "ar-001": "arabi mudernu",
            "arc": "aramaiku",
            "arn": "mapudũgũ",
            "arp": "araparu",
            "ars": "arabi negede",
            "arw": "arawaki",
            "as": "asamei",
            "asa": "asu",
            "ast": "asiturianu",
            "av": "awariku",
            "awa": "awadi",
            "ay": "aimará",
            "az": "aserbayanu",
            "az-Arab": "aseri sú",
            "ba": "baxikiri",
            "bal": "barúxi",
            "ban": "barinei",
            "bas": "basa",
            "bax": "bamũ",
            "bbj": "gumara",
            "be": "bierurusu",
            "bej": "beya",
            "bem": "bẽba",
            "bez": "bena",
            "bfd": "bafuti",
            "bg": "búgaru",
            "bgn": "baruxi usidẽtawara",
            "bho": "buyipuri",
            "bi": "bisiramá",
            "bik": "bikú",
            "bin": "biní",
            "bkm": "kũ",
            "bla": "sikisika",
            "bm": "bãbara",
            "bn": "bẽgari",
            "bo": "tibetanu",
            "br": "beretan",
            "bra": "barayi",
            "brx": "budu",
            "bs": "businiu",
            "bss": "akusi",
            "bua": "buriatu",
            "bug": "buginei",
            "bum": "buru",
            "byn": "birĩ",
            "byv": "medũba",
            "ca": "katará",
            "cad": "cadu",
            "car": "karibi",
            "cay": "kayuga",
            "cch": "atisã",
            "ccp": "xakima",
            "ce": "xexenu",
            "ceb": "sebuanu",
            "cgg": "xiga",
            "ch": "xamuru",
            "chb": "xibixa",
            "chg": "xagatai",
            "chk": "xukisi",
            "chm": "mari",
            "chn": "yarigan xinoki",
            "cho": "xokitau",
            "chp": "xipewiyã",
            "chr": "xerokí",
            "chy": "xeyeni",
            "ckb": "kurdu piterapura",
            "co": "curisu",
            "cop": "kupita",
            "cr": "kiri",
            "crh": "Kirimeya turiku",
            "crs": "kiriuru frãsei seixeriwara",
            "cs": "tieku",
            "csb": "kaxubiã",
            "cu": "isirawu ekeresiatiku",
            "cv": "tiuwaxi",
            "cy": "garei",
            "da": "dinamarikei",
            "dak": "dakuta",
            "dar": "darigiwa",
            "dav": "taita",
            "de": "areman",
            "de-AT": "areman (Ausitiriya)",
            "de-CH": "areman iwaté (Suisa)",
            "del": "deraware",
            "den": "isireivei",
            "dgr": "dogiri",
            "din": "dĩka",
            "dje": "sarima",
            "doi": "dogiribi",
            "dsb": "surábiu yatuka",
            "dua": "duara",
            "dum": "hurãdei médiu",
            "dv": "diweí",
            "dyo": "yora-funiyi",
            "dyu": "diura",
            "dz": "disũga",
            "dzg": "dasaga",
            "ebu": "ẽbu",
            "ee": "ewe",
            "efi": "efiki",
            "egy": "egipisiu arkaiku",
            "eka": "ekayuki",
            "el": "geregu",
            "elx": "eramite",
            "en": "ẽgirixi",
            "en-AU": "ẽgirixi (Ausitaraliya)",
            "en-CA": "ẽgirixi (Kanadá)",
            "en-GB": "ẽgirixi (Reyinu Yepewasú)",
            "en-US": "ẽgirixi (Tetãma-ita Yepewasú)",
            "enm": "ẽgirixi médiu",
            "eo": "esiperãtu",
            "es": "isipãyu",
            "es-419": "isipãyu (Amerika Latina)",
            "es-ES": "isipãyu (Isipãya)",
            "es-MX": "isipãyu (Mẽsiku)",
            "et": "eituniyanu",
            "eu": "basiku",
            "ewo": "ewũdu",
            "fa": "perisa",
            "fa-AF": "perisa (Afegãniretãma)",
            "fan": "fãge",
            "fat": "fãti",
            "ff": "fura",
            "fi": "firãdes",
            "fil": "firipinu",
            "fj": "fiyianu",
            "fo": "faruwesi",
            "fon": "fũmu",
            "fr": "frãsei",
            "fr-CA": "frãsei (Kanadá)",
            "fr-CH": "frãsei (Suwisa)",
            "frc": "frãsei kayũ",
            "frm": "frãsei médiu",
            "fro": "frãsei arkaiku",
            "frr": "firísiu setẽtiriunau",
            "frs": "firísiu usidẽtawara",
            "fur": "friuranu",
            "fy": "frísiu usidẽtawara",
            "ga": "irãdeixi médiu",
            "gaa": "ga",
            "gag": "gagausi",
            "gan": "gã",
            "gay": "gayu",
            "gba": "gibaya",
            "gd": "gaériku ekusei",
            "gez": "giixi",
            "gil": "giubetei",
            "gl": "garegu",
            "gmh": "areman iwaté médiu",
            "gn": "guwarani",
            "goh": "areman arkaiku iwaté",
            "gon": "gũdi",
            "gor": "gurũtaru",
            "got": "gútiku",
            "grb": "gerebu",
            "grc": "geregu arkaiku",
            "gsw": "areman (Suisa)",
            "gu": "guserate",
            "guz": "gusiyi",
            "gv": "mãkisi",
            "gwi": "guwixi-ĩ",
            "ha": "hausá",
            "hai": "haida",
            "hak": "haká",
            "haw": "hawayanu",
            "he": "heburaiku",
            "hi": "hĩdi",
            "hil": "irigainũ",
            "hit": "hitita",
            "hmn": "himũgi",
            "ho": "hiri mutu",
            "hr": "kuruata",
            "hsb": "surábiu iwaté",
            "hsn": "xiãgi",
            "ht": "haitianu",
            "hu": "ũgaru",
            "hup": "hupa",
            "hy": "arimẽniu",
            "hz": "hereru",
            "ia": "neẽgasuí",
            "iba": "ibã",
            "ibb": "ibibiu",
            "id": "ĩdunésiu",
            "ie": "neẽgapitera",
            "ig": "igibu",
            "ii": "sixuã yi",
            "ik": "inupiaki",
            "ilo": "irukanu",
            "inh": "ĩguxi",
            "io": "idu",
            "is": "isirãdei",
            "it": "itarianu",
            "iu": "inukitituti",
            "ja": "yapunei",
            "jbo": "ruyibã",
            "jgo": "ĩgẽba",
            "jmc": "maxami",
            "jpr": "yudaiku-perisa",
            "jrb": "yudaiku-arabiku",
            "jv": "yawanei",
            "ka": "geurgianu",
            "kaa": "kara-kaupaki",
            "kab": "kabire",
            "kac": "kaxĩ",
            "kaj": "iyu",
            "kam": "kãba",
            "kaw": "kawi",
            "kbd": "kabaridianu",
            "kbl": "kanẽbu",
            "kcg": "tiyapi",
            "kde": "makũdi",
            "kea": "kiriuru kabu-suikiriwara",
            "kfo": "kuru",
            "kg": "kũgurei",
            "kgp": "kaĩgãgi",
            "kha": "kasi",
            "kho": "kutanei",
            "khq": "kuyira xini",
            "ki": "kikuyu",
            "kj": "kuãyama",
            "kk": "kasaki",
            "kkj": "kaku",
            "kl": "guruẽrãdei",
            "kln": "karẽyĩ",
            "km": "kimé",
            "kmb": "kĩbũdu",
            "kn": "kanarĩ",
            "ko": "kurianu",
            "koi": "kumi-perimiaki",
            "kok": "kũkani",
            "kos": "kusirayã",
            "kpe": "kipere",
            "kr": "kanúri",
            "krc": "karaxai-bauká",
            "krl": "karériu",
            "kru": "kuruki",
            "ks": "kaxemira",
            "ksb": "xãbara",
            "ksf": "bafia",
            "ksh": "kurixi",
            "ku": "kurdu",
            "kum": "kumiki",
            "kut": "kutenai",
            "kv": "kumi",
            "kw": "kúriniku",
            "ky": "kirigixi",
            "la": "ratĩ",
            "lad": "radinu",
            "lag": "rãgi",
            "lah": "rãda",
            "lam": "rãba",
            "lb": "ruxẽbugei",
            "lez": "resigi",
            "lg": "rugãda",
            "li": "rĩburgei",
            "lij": "lij",
            "lkt": "rakuta",
            "ln": "rĩgana",
            "lo": "rausianu",
            "lol": "mũgu",
            "lou": "kiriuru ruisianawara",
            "loz": "rusi",
            "lrc": "ruri setẽtiriunau",
            "lt": "rituanu",
            "lu": "ruba-katãga",
            "lua": "ruba-rurua",
            "lui": "ruisenu",
            "lun": "rũda",
            "luo": "ruwu",
            "lus": "ruxai",
            "luy": "ruiya",
            "lv": "retan",
            "mad": "madurei",
            "maf": "mafa",
            "mag": "magarí",
            "mai": "maitiri",
            "mak": "makasá",
            "man": "mãdĩga",
            "mas": "masai",
            "mde": "maba",
            "mdf": "mukisa",
            "mdr": "mãdari",
            "men": "mẽde",
            "mer": "meru",
            "mfe": "murisiẽ",
            "mg": "maugaxe",
            "mga": "irãdei médiu",
            "mgh": "makua",
            "mgo": "metá",
            "mh": "marixarei",
            "mi": "mauri",
            "mic": "mikemake",
            "min": "minãgikabau",
            "mk": "masedũniu",
            "ml": "marayara",
            "mn": "mũgú",
            "mnc": "mãxu",
            "mni": "manipuri",
            "moh": "muikanu",
            "mos": "musi",
            "mr": "marati",
            "ms": "marayu",
            "mt": "mautei",
            "mua": "mũdãgi",
            "mul": "siía ñeẽga",
            "mus": "kirik",
            "mwl": "mirãdei",
            "mwr": "mariwari",
            "my": "birimanei",
            "mye": "miyene",
            "myv": "erisia",
            "mzn": "masãdarani",
            "na": "nauruanu",
            "nan": "mĩ nã",
            "nap": "napuritanu",
            "naq": "nama",
            "nb": "bukimau nuruegei",
            "nd": "ĩdebere nutiwara",
            "nds": "aremaũ yatuka",
            "nds-NL": "sakisan yatuka",
            "ne": "neparei",
            "new": "newari",
            "ng": "dũgu",
            "nia": "niyasi",
            "niu": "niweanu",
            "nl": "hurãdei",
            "nl-BE": "faramẽgu",
            "nmg": "kuwasiu",
            "nn": "ninorisiki nuruegei",
            "nnh": "ĩgiẽbũ",
            "no": "nuruegei",
            "nog": "nugai",
            "non": "núridiku arkaiku",
            "nqo": "nikú",
            "nr": "ĩdebere suwara",
            "nso": "sutu setẽtiriunau",
            "nus": "nuiri",
            "nv": "nawayu",
            "nwc": "newari katuwa",
            "ny": "niãya",
            "nym": "niãmuwesi",
            "nyn": "niãkuri",
            "nyo": "niyuru",
            "nzi": "ĩsima",
            "oc": "usitãniku",
            "oj": "uyibua",
            "om": "urumu",
            "or": "uriá",
            "os": "usetu",
            "osa": "usayi",
            "ota": "turiku utumanu",
            "pa": "pãyabi",
            "pag": "pãgasinã",
            "pal": "parawi",
            "pam": "pãpãga",
            "pap": "papiamẽtu",
            "pau": "parauanu",
            "pcm": "pidigĩ niyerianu",
            "peo": "persa arkaiku",
            "phn": "finísiu",
            "pi": "pári",
            "pl": "purunei",
            "pon": "pũpeianu",
            "prg": "purusianu",
            "pro": "puruwẽsau arkaiku",
            "ps": "paxitu",
            "pt": "putugei",
            "pt-BR": "putugei (Brasiu)",
            "pt-PT": "putugei (Putugau)",
            "qu": "kíxua",
            "quc": "kixé",
            "raj": "rayasitani",
            "rap": "rapanui",
            "rar": "rurutũganu",
            "rhg": "rhg",
            "rm": "rumãxi",
            "rn": "rũdi",
            "ro": "rumenu",
            "ro-MD": "mudáwiu",
            "rof": "rũbu",
            "rom": "rumani",
            "ru": "rusu",
            "rup": "arumenu",
            "rw": "kiniaruãda",
            "rwk": "ruwa",
            "sa": "sãsikiritu",
            "sad": "sãdawe",
            "sah": "saka",
            "sam": "aramaiku samaritanu",
            "saq": "sãburu",
            "sas": "sasak",
            "sat": "sãtari",
            "sba": "ĩgãbai",
            "sbp": "sãgu",
            "sc": "saridú",
            "scn": "sisirianu",
            "sco": "isiutis",
            "sd": "sĩdi",
            "sdh": "kuridu meridiunau",
            "se": "sami setẽtiriunau",
            "see": "seneka",
            "seh": "sena",
            "sel": "seukupi",
            "ses": "kuiraburu seni",
            "sg": "sãgú",
            "sga": "irãdesiarkaiku",
            "sh": "seriwu-kruata",
            "shi": "taxeriti",
            "shn": "xãni",
            "shu": "arabi xadianu",
            "si": "sĩgarei",
            "sid": "sidamu",
            "sk": "esiruwaku",
            "sl": "esiruwenu",
            "sm": "samuanu",
            "sma": "sami meridiunau",
            "smj": "sami Lulewara",
            "smn": "sami Inariwara",
            "sms": "sami Skoltwara",
            "sn": "xuna",
            "snk": "sunĩkê",
            "so": "sumari",
            "sog": "sugidianu",
            "sq": "aubanei",
            "sr": "sériwiu",
            "srn": "surinamei",
            "srr": "serere",
            "ss": "suási",
            "ssy": "saru",
            "st": "sutu suwara",
            "su": "sũdanei",
            "suk": "sukuma",
            "sus": "susu",
            "sux": "sumeriu",
            "sv": "sueku",
            "sw": "suaíri",
            "sw-CD": "suairi kũguwara",
            "swb": "kumurianu",
            "syc": "siriaku katuwa",
            "syr": "siriaku",
            "ta": "tamiu",
            "te": "térugu",
            "tem": "timine",
            "teo": "teso",
            "ter": "terenu",
            "tet": "tetũ",
            "tg": "tadiyike",
            "th": "tairãdei",
            "ti": "tigirínia",
            "tig": "tigiré",
            "tiv": "tivi",
            "tk": "turikumenu",
            "tkl": "tukerauanu",
            "tl": "tagaru",
            "tlh": "kirĩgũ",
            "tli": "tirĩgiti",
            "tmh": "tamaxeki",
            "tn": "tisuana",
            "to": "tũganei",
            "tog": "tũganei Niasawara",
            "tpi": "tuki pisĩ",
            "tr": "turku",
            "trv": "taruku",
            "ts": "tesũga",
            "tsi": "tesĩmĩxianu",
            "tt": "táritaru",
            "tum": "tũbuka",
            "tvl": "tuwaruanu",
            "tw": "tui",
            "twq": "tasawake",
            "ty": "taitianu",
            "tyv": "tuwinianu",
            "tzm": "tamasiriti Átras katuwa",
            "udm": "udimurite",
            "ug": "wiguri",
            "uga": "ugarítiku",
            "uk": "ukaranianu",
            "umb": "ũbũdu",
            "und": "ũba uyukuau ñeẽga",
            "ur": "urdu",
            "uz": "usibeki",
            "vai": "wai",
            "ve": "wẽda",
            "vi": "wietinamita",
            "vo": "wurapuke",
            "vot": "wútiku",
            "vun": "wũyu",
            "wa": "waran",
            "wae": "wauseri",
            "wal": "woraita",
            "war": "warai",
            "was": "waxu",
            "wbp": "waripiri",
            "wo": "worofi",
            "wuu": "wurapuki",
            "xal": "kaumiki",
            "xh": "xosa",
            "xog": "rusoga",
            "yao": "yau",
            "yap": "yapese",
            "yav": "yãgibẽ",
            "ybb": "yẽba",
            "yi": "yídixi",
            "yo": "yurubá",
            "yrl": "ñengatú",
            "yue": "kãtunei",
            "za": "suãgi",
            "zap": "saputeku",
            "zbl": "rãgasaitá brisi",
            "zen": "senaga",
            "zgh": "tamasiriti marukinu padran",
            "zh": "xinañeẽga",
            "zh-Hans": "xinañeẽga iwasuĩma",
            "zh-Hant": "xinañeẽga katuwa",
            "zu": "suru",
            "zun": "sũyi",
            "zxx": "ũba aykué ñeẽga sesewaraitá",
            "zza": "sasaki"
          },
          "narrow": {
          },
          "short": {
            "az": "aserbayanu",
            "en-GB": "ẽgirixi (Reyinu Yepewasú)",
            "en-US": "ẽgirixi (EUA)"
          }
        },
        "standard": {
          "long": {
            "aa": "afari",
            "ab": "abikasiyu",
            "ace": "axemi",
            "ach": "akuri",
            "ada": "adãgime",
            "ady": "adige",
            "ae": "awesitiku",
            "af": "afiriķãner",
            "afh": "afirihiri",
            "agq": "agẽ",
            "ain": "ainú",
            "ak": "akã",
            "akk": "akadiãnu",
            "ale": "areúti",
            "alt": "autai meridiunau",
            "am": "amáriku",
            "an": "aragunẽi",
            "ang": "ẽgirixi arkaiku",
            "anp": "ãyika",
            "ar": "arabi",
            "ar-001": "arabi (Iwi)",
            "arc": "aramaiku",
            "arn": "mapudũgũ",
            "arp": "araparu",
            "ars": "arabi negede",
            "arw": "arawaki",
            "as": "asamei",
            "asa": "asu",
            "ast": "asiturianu",
            "av": "awariku",
            "awa": "awadi",
            "ay": "aimará",
            "az": "aserbayanu",
            "az-Arab": "aseri sú",
            "ba": "baxikiri",
            "bal": "barúxi",
            "ban": "barinei",
            "bas": "basa",
            "bax": "bamũ",
            "bbj": "gumara",
            "be": "bierurusu",
            "bej": "beya",
            "bem": "bẽba",
            "bez": "bena",
            "bfd": "bafuti",
            "bg": "búgaru",
            "bgn": "baruxi usidẽtawara",
            "bho": "buyipuri",
            "bi": "bisiramá",
            "bik": "bikú",
            "bin": "biní",
            "bkm": "kũ",
            "bla": "sikisika",
            "bm": "bãbara",
            "bn": "bẽgari",
            "bo": "tibetanu",
            "br": "beretan",
            "bra": "barayi",
            "brx": "budu",
            "bs": "businiu",
            "bss": "akusi",
            "bua": "buriatu",
            "bug": "buginei",
            "bum": "buru",
            "byn": "birĩ",
            "byv": "medũba",
            "ca": "katará",
            "cad": "cadu",
            "car": "karibi",
            "cay": "kayuga",
            "cch": "atisã",
            "ccp": "xakima",
            "ce": "xexenu",
            "ceb": "sebuanu",
            "cgg": "xiga",
            "ch": "xamuru",
            "chb": "xibixa",
            "chg": "xagatai",
            "chk": "xukisi",
            "chm": "mari",
            "chn": "yarigan xinoki",
            "cho": "xokitau",
            "chp": "xipewiyã",
            "chr": "xerokí",
            "chy": "xeyeni",
            "ckb": "kurdu piterapura",
            "co": "curisu",
            "cop": "kupita",
            "cr": "kiri",
            "crh": "Kirimeya turiku",
            "crs": "kiriuru frãsei seixeriwara",
            "cs": "tieku",
            "csb": "kaxubiã",
            "cu": "isirawu ekeresiatiku",
            "cv": "tiuwaxi",
            "cy": "garei",
            "da": "dinamarikei",
            "dak": "dakuta",
            "dar": "darigiwa",
            "dav": "taita",
            "de": "areman",
            "de-AT": "areman (Ausitiriya)",
            "de-CH": "areman (Suwisa)",
            "del": "deraware",
            "den": "isireivei",
            "dgr": "dogiri",
            "din": "dĩka",
            "dje": "sarima",
            "doi": "dogiribi",
            "dsb": "surábiu yatuka",
            "dua": "duara",
            "dum": "hurãdei médiu",
            "dv": "diweí",
            "dyo": "yora-funiyi",
            "dyu": "diura",
            "dz": "disũga",
            "dzg": "dasaga",
            "ebu": "ẽbu",
            "ee": "ewe",
            "efi": "efiki",
            "egy": "egipisiu arkaiku",
            "eka": "ekayuki",
            "el": "geregu",
            "elx": "eramite",
            "en": "ẽgirixi",
            "en-AU": "ẽgirixi (Ausitaraliya)",
            "en-CA": "ẽgirixi (Kanadá)",
            "en-GB": "ẽgirixi (Reyinu Yepewasú)",
            "en-US": "ẽgirixi (Tetãma-ita Yepewasú)",
            "enm": "ẽgirixi médiu",
            "eo": "esiperãtu",
            "es": "isipãyu",
            "es-419": "isipãyu (Amerika Latina)",
            "es-ES": "isipãyu (Isipãya)",
            "es-MX": "isipãyu (Mẽsiku)",
            "et": "eituniyanu",
            "eu": "basiku",
            "ewo": "ewũdu",
            "fa": "perisa",
            "fa-AF": "perisa (Afegãniretãma)",
            "fan": "fãge",
            "fat": "fãti",
            "ff": "fura",
            "fi": "firãdes",
            "fil": "firipinu",
            "fj": "fiyianu",
            "fo": "faruwesi",
            "fon": "fũmu",
            "fr": "frãsei",
            "fr-CA": "frãsei (Kanadá)",
            "fr-CH": "frãsei (Suwisa)",
            "frc": "frãsei kayũ",
            "frm": "frãsei médiu",
            "fro": "frãsei arkaiku",
            "frr": "firísiu setẽtiriunau",
            "frs": "firísiu usidẽtawara",
            "fur": "friuranu",
            "fy": "frísiu usidẽtawara",
            "ga": "irãdeixi médiu",
            "gaa": "ga",
            "gag": "gagausi",
            "gan": "gã",
            "gay": "gayu",
            "gba": "gibaya",
            "gd": "gaériku ekusei",
            "gez": "giixi",
            "gil": "giubetei",
            "gl": "garegu",
            "gmh": "areman iwaté médiu",
            "gn": "guwarani",
            "goh": "areman arkaiku iwaté",
            "gon": "gũdi",
            "gor": "gurũtaru",
            "got": "gútiku",
            "grb": "gerebu",
            "grc": "geregu arkaiku",
            "gsw": "areman (Suisa)",
            "gu": "guserate",
            "guz": "gusiyi",
            "gv": "mãkisi",
            "gwi": "guwixi-ĩ",
            "ha": "hausá",
            "hai": "haida",
            "hak": "haká",
            "haw": "hawayanu",
            "he": "heburaiku",
            "hi": "hĩdi",
            "hil": "irigainũ",
            "hit": "hitita",
            "hmn": "himũgi",
            "ho": "hiri mutu",
            "hr": "kuruata",
            "hsb": "surábiu iwaté",
            "hsn": "xiãgi",
            "ht": "haitianu",
            "hu": "ũgaru",
            "hup": "hupa",
            "hy": "arimẽniu",
            "hz": "hereru",
            "ia": "neẽgasuí",
            "iba": "ibã",
            "ibb": "ibibiu",
            "id": "ĩdunésiu",
            "ie": "neẽgapitera",
            "ig": "igibu",
            "ii": "sixuã yi",
            "ik": "inupiaki",
            "ilo": "irukanu",
            "inh": "ĩguxi",
            "io": "idu",
            "is": "isirãdei",
            "it": "itarianu",
            "iu": "inukitituti",
            "ja": "yapunei",
            "jbo": "ruyibã",
            "jgo": "ĩgẽba",
            "jmc": "maxami",
            "jpr": "yudaiku-perisa",
            "jrb": "yudaiku-arabiku",
            "jv": "yawanei",
            "ka": "geurgianu",
            "kaa": "kara-kaupaki",
            "kab": "kabire",
            "kac": "kaxĩ",
            "kaj": "iyu",
            "kam": "kãba",
            "kaw": "kawi",
            "kbd": "kabaridianu",
            "kbl": "kanẽbu",
            "kcg": "tiyapi",
            "kde": "makũdi",
            "kea": "kiriuru kabu-suikiriwara",
            "kfo": "kuru",
            "kg": "kũgurei",
            "kgp": "kaĩgãgi",
            "kha": "kasi",
            "kho": "kutanei",
            "khq": "kuyira xini",
            "ki": "kikuyu",
            "kj": "kuãyama",
            "kk": "kasaki",
            "kkj": "kaku",
            "kl": "guruẽrãdei",
            "kln": "karẽyĩ",
            "km": "kimé",
            "kmb": "kĩbũdu",
            "kn": "kanarĩ",
            "ko": "kurianu",
            "koi": "kumi-perimiaki",
            "kok": "kũkani",
            "kos": "kusirayã",
            "kpe": "kipere",
            "kr": "kanúri",
            "krc": "karaxai-bauká",
            "krl": "karériu",
            "kru": "kuruki",
            "ks": "kaxemira",
            "ksb": "xãbara",
            "ksf": "bafia",
            "ksh": "kurixi",
            "ku": "kurdu",
            "kum": "kumiki",
            "kut": "kutenai",
            "kv": "kumi",
            "kw": "kúriniku",
            "ky": "kirigixi",
            "la": "ratĩ",
            "lad": "radinu",
            "lag": "rãgi",
            "lah": "rãda",
            "lam": "rãba",
            "lb": "ruxẽbugei",
            "lez": "resigi",
            "lg": "rugãda",
            "li": "rĩburgei",
            "lij": "lij",
            "lkt": "rakuta",
            "ln": "rĩgana",
            "lo": "rausianu",
            "lol": "mũgu",
            "lou": "kiriuru ruisianawara",
            "loz": "rusi",
            "lrc": "ruri setẽtiriunau",
            "lt": "rituanu",
            "lu": "ruba-katãga",
            "lua": "ruba-rurua",
            "lui": "ruisenu",
            "lun": "rũda",
            "luo": "ruwu",
            "lus": "ruxai",
            "luy": "ruiya",
            "lv": "retan",
            "mad": "madurei",
            "maf": "mafa",
            "mag": "magarí",
            "mai": "maitiri",
            "mak": "makasá",
            "man": "mãdĩga",
            "mas": "masai",
            "mde": "maba",
            "mdf": "mukisa",
            "mdr": "mãdari",
            "men": "mẽde",
            "mer": "meru",
            "mfe": "murisiẽ",
            "mg": "maugaxe",
            "mga": "irãdei médiu",
            "mgh": "makua",
            "mgo": "metá",
            "mh": "marixarei",
            "mi": "mauri",
            "mic": "mikemake",
            "min": "minãgikabau",
            "mk": "masedũniu",
            "ml": "marayara",
            "mn": "mũgú",
            "mnc": "mãxu",
            "mni": "manipuri",
            "moh": "muikanu",
            "mos": "musi",
            "mr": "marati",
            "ms": "marayu",
            "mt": "mautei",
            "mua": "mũdãgi",
            "mul": "siía ñeẽga",
            "mus": "kirik",
            "mwl": "mirãdei",
            "mwr": "mariwari",
            "my": "birimanei",
            "mye": "miyene",
            "myv": "erisia",
            "mzn": "masãdarani",
            "na": "nauruanu",
            "nan": "mĩ nã",
            "nap": "napuritanu",
            "naq": "nama",
            "nb": "bukimau nuruegei",
            "nd": "ĩdebere nutiwara",
            "nds": "aremaũ yatuka",
            "nds-NL": "aremaũ yatuka (Tetãma Iwiboí-ita)",
            "ne": "neparei",
            "new": "newari",
            "ng": "dũgu",
            "nia": "niyasi",
            "niu": "niweanu",
            "nl": "hurãdei",
            "nl-BE": "hurãdei (Beujika)",
            "nmg": "kuwasiu",
            "nn": "ninorisiki nuruegei",
            "nnh": "ĩgiẽbũ",
            "no": "nuruegei",
            "nog": "nugai",
            "non": "núridiku arkaiku",
            "nqo": "nikú",
            "nr": "ĩdebere suwara",
            "nso": "sutu setẽtiriunau",
            "nus": "nuiri",
            "nv": "nawayu",
            "nwc": "newari katuwa",
            "ny": "niãya",
            "nym": "niãmuwesi",
            "nyn": "niãkuri",
            "nyo": "niyuru",
            "nzi": "ĩsima",
            "oc": "usitãniku",
            "oj": "uyibua",
            "om": "urumu",
            "or": "uriá",
            "os": "usetu",
            "osa": "usayi",
            "ota": "turiku utumanu",
            "pa": "pãyabi",
            "pag": "pãgasinã",
            "pal": "parawi",
            "pam": "pãpãga",
            "pap": "papiamẽtu",
            "pau": "parauanu",
            "pcm": "pidigĩ niyerianu",
            "peo": "persa arkaiku",
            "phn": "finísiu",
            "pi": "pári",
            "pl": "purunei",
            "pon": "pũpeianu",
            "prg": "purusianu",
            "pro": "puruwẽsau arkaiku",
            "ps": "paxitu",
            "pt": "putugei",
            "pt-BR": "putugei (Brasiu)",
            "pt-PT": "putugei (Putugau)",
            "qu": "kíxua",
            "quc": "kixé",
            "raj": "rayasitani",
            "rap": "rapanui",
            "rar": "rurutũganu",
            "rhg": "rhg",
            "rm": "rumãxi",
            "rn": "rũdi",
            "ro": "rumenu",
            "ro-MD": "rumenu (Mũduwa)",
            "rof": "rũbu",
            "rom": "rumani",
            "ru": "rusu",
            "rup": "arumenu",
            "rw": "kiniaruãda",
            "rwk": "ruwa",
            "sa": "sãsikiritu",
            "sad": "sãdawe",
            "sah": "saka",
            "sam": "aramaiku samaritanu",
            "saq": "sãburu",
            "sas": "sasak",
            "sat": "sãtari",
            "sba": "ĩgãbai",
            "sbp": "sãgu",
            "sc": "saridú",
            "scn": "sisirianu",
            "sco": "isiutis",
            "sd": "sĩdi",
            "sdh": "kuridu meridiunau",
            "se": "sami setẽtiriunau",
            "see": "seneka",
            "seh": "sena",
            "sel": "seukupi",
            "ses": "kuiraburu seni",
            "sg": "sãgú",
            "sga": "irãdesiarkaiku",
            "sh": "seriwu-kruata",
            "shi": "taxeriti",
            "shn": "xãni",
            "shu": "arabi xadianu",
            "si": "sĩgarei",
            "sid": "sidamu",
            "sk": "esiruwaku",
            "sl": "esiruwenu",
            "sm": "samuanu",
            "sma": "sami meridiunau",
            "smj": "sami Lulewara",
            "smn": "sami Inariwara",
            "sms": "sami Skoltwara",
            "sn": "xuna",
            "snk": "sunĩkê",
            "so": "sumari",
            "sog": "sugidianu",
            "sq": "aubanei",
            "sr": "sériwiu",
            "srn": "surinamei",
            "srr": "serere",
            "ss": "suási",
            "ssy": "saru",
            "st": "sutu suwara",
            "su": "sũdanei",
            "suk": "sukuma",
            "sus": "susu",
            "sux": "sumeriu",
            "sv": "sueku",
            "sw": "suaíri",
            "sw-CD": "suaíri (Kũgu - Kĩxasa)",
            "swb": "kumurianu",
            "syc": "siriaku katuwa",
            "syr": "siriaku",
            "ta": "tamiu",
            "te": "térugu",
            "tem": "timine",
            "teo": "teso",
            "ter": "terenu",
            "tet": "tetũ",
            "tg": "tadiyike",
            "th": "tairãdei",
            "ti": "tigirínia",
            "tig": "tigiré",
            "tiv": "tivi",
            "tk": "turikumenu",
            "tkl": "tukerauanu",
            "tl": "tagaru",
            "tlh": "kirĩgũ",
            "tli": "tirĩgiti",
            "tmh": "tamaxeki",
            "tn": "tisuana",
            "to": "tũganei",
            "tog": "tũganei Niasawara",
            "tpi": "tuki pisĩ",
            "tr": "turku",
            "trv": "taruku",
            "ts": "tesũga",
            "tsi": "tesĩmĩxianu",
            "tt": "táritaru",
            "tum": "tũbuka",
            "tvl": "tuwaruanu",
            "tw": "tui",
            "twq": "tasawake",
            "ty": "taitianu",
            "tyv": "tuwinianu",
            "tzm": "tamasiriti Átras katuwa",
            "udm": "udimurite",
            "ug": "wiguri",
            "uga": "ugarítiku",
            "uk": "ukaranianu",
            "umb": "ũbũdu",
            "und": "ũba uyukuau ñeẽga",
            "ur": "urdu",
            "uz": "usibeki",
            "vai": "wai",
            "ve": "wẽda",
            "vi": "wietinamita",
            "vo": "wurapuke",
            "vot": "wútiku",
            "vun": "wũyu",
            "wa": "waran",
            "wae": "wauseri",
            "wal": "woraita",
            "war": "warai",
            "was": "waxu",
            "wbp": "waripiri",
            "wo": "worofi",
            "wuu": "wurapuki",
            "xal": "kaumiki",
            "xh": "xosa",
            "xog": "rusoga",
            "yao": "yau",
            "yap": "yapese",
            "yav": "yãgibẽ",
            "ybb": "yẽba",
            "yi": "yídixi",
            "yo": "yurubá",
            "yrl": "ñengatú",
            "yue": "kãtunei",
            "za": "suãgi",
            "zap": "saputeku",
            "zbl": "rãgasaitá brisi",
            "zen": "senaga",
            "zgh": "tamasiriti marukinu padran",
            "zh": "xinañeẽga",
            "zh-Hans": "xinañeẽga iwasuĩma",
            "zh-Hant": "xinañeẽga katuwa",
            "zu": "suru",
            "zun": "sũyi",
            "zxx": "ũba aykué ñeẽga sesewaraitá",
            "zza": "sasaki"
          },
          "narrow": {
          },
          "short": {
            "az": "aserbayanu",
            "en-GB": "ẽgirixi (Reyinu Yepewasú)",
            "en-US": "ẽgirixi (EUA)"
          }
        }
      },
      "region": {
        "long": {
          "001": "Iwi",
          "002": "Afirika",
          "003": "Amerika Nuti suí",
          "005": "Amerika Su suí",
          "009": "Useãniya",
          "011": "Afirika Usidẽtawara",
          "013": "Amerika Piterapura",
          "014": "Afirika Uriẽtawara",
          "015": "Afirika Nuti suí",
          "017": "Afirika Piterapura",
          "018": "Afirika Meridiyunau",
          "019": "America-ita",
          "021": "Amerika Setẽtiriunau",
          "029": "Karíbi",
          "030": "Ásiya Uriẽtawara",
          "034": "Ásiya Meridiyunau",
          "035": "Sudeti Ásiyatiku",
          "039": "Eurupa Meridiyunau",
          "053": "Ausitarasia",
          "054": "Meranésiya",
          "057": "Micuronesiya Tetãma",
          "061": "Pulinesiya",
          "142": "Ásiya",
          "143": "Ásiya Piterapura",
          "145": "Ásiya Usidẽtawara",
          "150": "Eurupa",
          "151": "Eurupa Uriẽtawara",
          "154": "Eurupa Setẽtiriunau",
          "155": "Eurupa Usidẽtawara",
          "202": "Afirika Subisariana",
          "419": "Amerika Latina",
          "AC": "Asesan Kapuãma",
          "AD": "Ãdura",
          "AE": "Emiradu Árabi Yepewasuwaitá",
          "AF": "Afegãniretãma",
          "AG": "Ãtigua asuí Babuda",
          "AI": "Ãgira",
          "AL": "Aubãniya",
          "AM": "Arimẽniya",
          "AO": "Ãgura",
          "AQ": "Ãtartida",
          "AR": "Argẽtina",
          "AS": "Samua Amerikiwara",
          "AT": "Ausitiriya",
          "AU": "Ausitaraliya",
          "AW": "Aruba",
          "AX": "Kapuãma-ita Arãdi",
          "AZ": "Aseriretãma",
          "BA": "Businiya asuí Eseguwina",
          "BB": "Babadu",
          "BD": "Bãgaradexi",
          "BE": "Beujika",
          "BF": "Bukina Fasu",
          "BG": "Bugáriya",
          "BH": "Barẽi",
          "BI": "Burũdi",
          "BJ": "Benĩ",
          "BL": "San Batulumeu",
          "BM": "Bemuda",
          "BN": "Burunei",
          "BO": "Buríwia",
          "BQ": "Tetãma Iwiboí-ita Karíbi suí",
          "BR": "Brasiu",
          "BS": "Bayama",
          "BT": "Butan",
          "BV": "Kapuãma Buweti",
          "BW": "Butisuwana",
          "BY": "Bieru-rúsiya",
          "BZ": "Belisi",
          "CA": "Kanadá",
          "CC": "Kapuãma-ita Kuku (Keering)",
          "CD": "Kũgu - Kĩxasa",
          "CF": "Repubirika Afirika-Piterapura",
          "CG": "Repubirika Kũguyara",
          "CH": "Suwisa",
          "CI": "Mafim Kupé",
          "CK": "Kapuãma-ita Kooki",
          "CL": "Xiri",
          "CM": "Puty-ita",
          "CN": "Xina",
          "CO": "Kurũbiya",
          "CP": "Kiripetũ Kapuãma",
          "CR": "Koñta Rika",
          "CU": "Kuba",
          "CV": "Kabu Suikiri",
          "CW": "Kurasau",
          "CX": "Kapuãma Kiritima",
          "CY": "Xipiri",
          "CZ": "Xekiya",
          "DE": "Aremãya",
          "DG": "Diyegu Garasiya",
          "DJ": "Dijibuti",
          "DK": "Dinamaka",
          "DM": "Dominika",
          "DO": "Repubirika Duminikana",
          "DZ": "Argeriya",
          "EA": "Seuta asuí Merira",
          "EC": "Ekuadú",
          "EE": "Isituniya",
          "EG": "Egitu",
          "EH": "Saara Usidẽtawara",
          "ER": "Eritireya",
          "ES": "Isipãya",
          "ET": "Etiupiya",
          "EU": "Eurupa Yepewasusawa",
          "EZ": "euru suna",
          "FI": "Firãdiya",
          "FJ": "Fiyi",
          "FK": "Kapuãma-ita Mawina",
          "FM": "Mikuruneziya",
          "FO": "Kapuãma-ita Faruwe",
          "FR": "Frãsa",
          "GA": "Gaban",
          "GB": "Reyinu Yepewasú",
          "GD": "Garanada",
          "GE": "Geugiya",
          "GF": "Giyana Frãsa yara",
          "GG": "Guwẽnisei",
          "GH": "Gana",
          "GI": "Gibarautá",
          "GL": "Guruẽrãdiya",
          "GM": "Gãbiya",
          "GN": "Giné",
          "GP": "Guadarupi",
          "GQ": "Giné Ekuaturiyau",
          "GR": "Geresiya",
          "GS": "Kapuãma-ita Geugiya Su asuí Sãduwixi Su",
          "GT": "Guatemara",
          "GU": "Guwã",
          "GW": "Giné Bisau",
          "GY": "Giyana",
          "HK": "Hũgi Kũgi, RAE Xina yara",
          "HM": "Kapuãma-ita Heard asuí McDonald",
          "HN": "Ũdura",
          "HR": "Kuruwasiya",
          "HT": "Aití",
          "HU": "Ũgiriya",
          "IC": "Kapuãma-ita Kanariya",
          "ID": "Ĩdunesiya",
          "IE": "Irãda",
          "IL": "Isirayeu",
          "IM": "Mã Kapuãma",
          "IN": "Ĩdiya",
          "IO": "Biritãniku Usuasawa Useyanu Ĩdiku",
          "IQ": "Iraki",
          "IR": "Irã",
          "IS": "Isirãdiya",
          "IT": "Itariya",
          "JE": "Yesei",
          "JM": "Yamaika",
          "JO": "Yudãniya",
          "JP": "Nipõ",
          "KE": "Kẽniya",
          "KG": "Kirigiretãma",
          "KH": "Kãbuya",
          "KI": "Kiribati",
          "KM": "Kumure-ita",
          "KN": "San Kirituwan suí Newi",
          "KP": "Kureya Nuti suí",
          "KR": "Kureya Su suí",
          "KW": "Kuwaiti",
          "KY": "Kapuãma-ita Kaimã",
          "KZ": "Kasakiretãma",
          "LA": "Rawo",
          "LB": "Ribanu",
          "LC": "Sãta Lusiya",
          "LI": "Rixitẽxitaĩ",
          "LK": "Siri Rãka",
          "LR": "Ribériya",
          "LS": "Resutu",
          "LT": "Rituwãniya",
          "LU": "Ruxẽbugu",
          "LV": "Retuniya",
          "LY": "Ribiya",
          "MA": "Maruku",
          "MC": "Mũnaku",
          "MD": "Mũduwa",
          "ME": "Mũteneguru",
          "MF": "Sã Matiyũ",
          "MG": "Madagasiká",
          "MH": "Kapuãma-ita Marshall",
          "MK": "Masedũniya",
          "ML": "Mari",
          "MM": "Miyamá (Bimãniya)",
          "MN": "Mũguriya",
          "MO": "Makau, RAE Xina yara",
          "MP": "Kapuãma-ita Mariyãna Nuti suí",
          "MQ": "Matinika",
          "MR": "Mauritaniya",
          "MS": "Mũtiserati",
          "MT": "Mauta",
          "MU": "Maurisiyu",
          "MV": "Maudiwa-ita",
          "MW": "Marawi",
          "MX": "Mẽsiku",
          "MY": "Malasiya",
          "MZ": "Musãbiki",
          "NA": "Namíbiya",
          "NC": "Karedũniya Pisasú",
          "NE": "Nige",
          "NF": "Kapuãma Norfolk",
          "NG": "Nigeriya",
          "NI": "Nicaraguwa",
          "NL": "Tetãma Iwiboí-ita",
          "NO": "Nuruwega",
          "NP": "Nepau",
          "NR": "Nauru",
          "NU": "Niwe",
          "NZ": "Serãdiya Pisasú",
          "OM": "Umã",
          "PA": "Panamã",
          "PE": "Peru",
          "PF": "Pulinesiya Frãsa yara",
          "PG": "Papuwa-Giné Pisasú",
          "PH": "Firipina",
          "PK": "Pakiretãma",
          "PL": "Puluniya",
          "PM": "San Peduru asuí Mikelan",
          "PN": "Kapuãma-ita Pitcairn",
          "PR": "Igarapawa Riku",
          "PS": "Tetãma Paretinu-ita yara",
          "PT": "Putugau",
          "PW": "Parau",
          "PY": "Paraguwai",
          "QA": "Katara",
          "QO": "Useãniya (R)",
          "RE": "Yumuatirisawa",
          "RO": "Romẽniya",
          "RS": "Sewiya",
          "RU": "Rusiya",
          "RW": "Huãda",
          "SA": "Arawia Saudita",
          "SB": "Kapuãma-ita Sarumũ",
          "SC": "Seixeri",
          "SD": "Ausudã",
          "SE": "Suwesiya",
          "SG": "Sĩgapura",
          "SH": "Sãta Erena",
          "SI": "Esiruwẽniya",
          "SJ": "Siwaubati asuí Yã Mayeni",
          "SK": "Esiruwakiya",
          "SL": "Iwitera Leowa",
          "SM": "Sã Marino",
          "SN": "Senegau",
          "SO": "Somariya",
          "SR": "Suriname",
          "SS": "Ausudã Su suí",
          "ST": "Sã Tumé asuí Pirĩsipe",
          "SV": "Eru Sawadu",
          "SX": "Sĩti Maatẽ",
          "SY": "Siriya",
          "SZ": "Esuatíni",
          "TA": "Tiritan Kũya",
          "TC": "Kapuãma-ita Tuka-ita asuí Kaiko-ita",
          "TD": "Xade",
          "TF": "Tetãma Su-ita Frãsa suí",
          "TG": "Togu",
          "TH": "Tairetãma",
          "TJ": "Tayikiretãma",
          "TK": "Tukerau",
          "TL": "Timu-Semusawa",
          "TM": "Turkuranaretãma",
          "TN": "Tunisiya",
          "TO": "Tõga",
          "TR": "Tukíya",
          "TT": "Tirinidadi asuí Tobagu",
          "TV": "Tuwaru",
          "TW": "Taiwã",
          "TZ": "Tãsaniya",
          "UA": "Ukarãniya",
          "UG": "Ugãda",
          "UM": "Kapuãma Kuiriwaita Apekatu EUA suí",
          "UN": "Nasan Yepewasuwaitá",
          "US": "Tetãma-ita Yepewasú",
          "UY": "Uruguwai",
          "UZ": "Yũbuesara-retãma",
          "VA": "Watikanu Tawa-wasu",
          "VC": "Sã Wisẽti asuí Garanadĩna-ita",
          "VE": "Wenesuera",
          "VG": "Kapuã-ita Viyẽ-ita Biritãnika-ita",
          "VI": "Kapuã-ira Viyẽ-ita Amerikana-ita",
          "VN": "Wiyetinã",
          "VU": "Wanuatu",
          "WF": "Wari asuí Futuna",
          "WS": "Samowa",
          "XA": "Sutakirana-ita",
          "XB": "Bidiresiunaurana",
          "XK": "Kusuwu",
          "YE": "Yemẽ",
          "YT": "Mayuti",
          "ZA": "Afirika Su suí",
          "ZM": "Sãbiya",
          "ZW": "Sĩbabuwe",
          "ZZ": "Tetãma Ũbawaukuamamẽ"
        },
        "narrow": {
        },
        "short": {
          "GB": "Reyinu Yepewasú",
          "HK": "Hũgi Kũgi",
          "MO": "Makau",
          "PS": "Paretina",
          "UN": "ONU",
          "US": "EUA"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "arabika",
          "Aran": "Aran",
          "Armi": "arimi",
          "Armn": "arimẽniu",
          "Avst": "awétiku",
          "Bali": "barineisi",
          "Bamu": "bamũ",
          "Bass": "Bass",
          "Batk": "bataki",
          "Beng": "bẽgari",
          "Bhks": "Bhks",
          "Blis": "rãgasaitá bliss",
          "Bopo": "bupumufu",
          "Brah": "brami",
          "Brai": "braire",
          "Bugi": "buginei",
          "Buhd": "buwidi",
          "Cakm": "kakimi",
          "Cans": "yũpinimasá síraba irũ aburíjini kanadáwara suí",
          "Cari": "karianu",
          "Cham": "xãmi",
          "Cher": "xerokí",
          "Chrs": "Chrs",
          "Cirt": "runikarana",
          "Copt": "kupitiku",
          "Cpmn": "Cpmn",
          "Cprt": "sipiriuta",
          "Cyrl": "siríriku",
          "Cyrs": "siríriku isirawu ekeresiatiku",
          "Deva": "dewanagari",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "desereti",
          "Dupl": "Dupl",
          "Egyd": "demútiku egipisiu",
          "Egyh": "ierátiku egipisiu",
          "Egyp": "egipsiu-ita kuatiara kuxiímawara",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "etiúpiku",
          "Geok": "kutisuri geurgianu",
          "Geor": "geurgianu",
          "Glag": "garagurítiku",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "gútiku",
          "Gran": "Gran",
          "Grek": "geregu",
          "Gujr": "guserati",
          "Guru": "gumuki",
          "Hanb": "hãbi",
          "Hang": "hãgu",
          "Hani": "hã",
          "Hano": "hanunu",
          "Hans": "iwasuĩma",
          "Hant": "katuwa",
          "Hatr": "Hatr",
          "Hebr": "heburaiku",
          "Hira": "hiragana",
          "Hluw": "Hluw",
          "Hmng": "parau himũgi",
          "Hmnp": "Hmnp",
          "Hrkt": "yapunei síraba irũ",
          "Hung": "ũgaru kuxiímawara",
          "Inds": "ĩdu",
          "Ital": "itáriku kuxiímawara",
          "Jamo": "yamu",
          "Java": "yawanei",
          "Jpan": "yapunei",
          "Kali": "kaya ri",
          "Kana": "katakaná",
          "Khar": "karuxiti",
          "Khmr": "kimé",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "kãnará",
          "Kore": "kureanu",
          "Kthi": "kiti",
          "Lana": "rana",
          "Laoo": "rau",
          "Latf": "ratĩ farakitú",
          "Latg": "ratĩ gaériku",
          "Latn": "ratĩ",
          "Lepc": "repixa",
          "Limb": "rĩbu",
          "Lina": "satãbika A",
          "Linb": "satãbika B",
          "Lisu": "risu",
          "Lyci": "rísiu",
          "Lydi": "rídiu",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "mãdaiku",
          "Mani": "manikeanu",
          "Marc": "Marc",
          "Maya": "maya-ita kuatiara kuxiímawara",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "meruítiku kusiwu",
          "Mero": "meruítiku",
          "Mlym": "marayara",
          "Modi": "Modi",
          "Mong": "mũgú",
          "Moon": "Moon kuatiara",
          "Mroo": "Mroo",
          "Mtei": "manipuri kuatiara",
          "Mult": "Mult",
          "Mymr": "birimanei",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "ĩku",
          "Nshu": "Nshu",
          "Ogam": "ugãmiku",
          "Olck": "uxiki",
          "Orkh": "urikũ",
          "Orya": "uriá",
          "Osge": "Osge",
          "Osma": "usmania",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "périmiku kuxiímawara",
          "Phag": "phagipa",
          "Phli": "phli",
          "Phlp": "phlp",
          "Phlv": "paravi kuxiímawara",
          "Phnx": "finísiu",
          "Plrd": "funétiku miau",
          "Prti": "prti",
          "Qaag": "Qaag",
          "Rjng": "reyãgi",
          "Rohg": "Rohg",
          "Roro": "rũgurũgu",
          "Runr": "rúniku",
          "Samr": "samaritanu",
          "Sara": "sarati",
          "Sarb": "Sarb",
          "Saur": "sauraxitara",
          "Sgnw": "sãgawa kuatiara",
          "Shaw": "xawianu",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "sĩgarei",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "sudãnei",
          "Sylo": "siruti nagiri",
          "Syrc": "siríaku",
          "Syre": "siríaku esitarãgeru",
          "Syrj": "siriaku usidẽtawara",
          "Syrn": "siriaku uriẽtawara",
          "Tagb": "tagibanua",
          "Takr": "Takr",
          "Tale": "tai re",
          "Talu": "tai rue pisasú",
          "Taml": "tãmiu",
          "Tang": "Tang",
          "Tavt": "tawiti",
          "Telu": "térugu",
          "Teng": "tẽguwari",
          "Tfng": "tifinagi",
          "Tglg": "tagaru",
          "Thaa": "ta-ana",
          "Thai": "tairãdei",
          "Tibt": "tibetanu",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "ugarítiku",
          "Vaii": "wai",
          "Visp": "ñeẽga xipiawera",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "perisa kuxiímawara",
          "Xsux": "sumériu-akadianu kune-sãgawa",
          "Yezi": "Yezi",
          "Yiii": "yi",
          "Zanb": "Zanb",
          "Zinh": "tauxariwa",
          "Zmth": "matemátika kuatiara",
          "Zsye": "Emuyi",
          "Zsym": "zsym",
          "Zxxx": "yũpinimasáĩma",
          "Zyyy": "mayewera",
          "Zzzz": "yũpinimasá ũbawa uyukuau"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "yrl-CO"
})
}